import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import Child from "@view/manage/child/Child";
import Profile from "@view/manage/profile/Profile";
import AddAndEditChild from "@view/manage/addAndEditChild/AddAndEditChild";
import LinkedParents from "@view/linkedParents/LinkedParents";
import SchedulePermission from "@view/manage/SchedulePermission/SchedulePermission";
import ManageCreditCards from "@view/manage/creditCard/ManageCreditCards";

const ManageRoute = withRouter(() => {
  return (
    <Switch>
      <Route
        path="/dashboard/manage/profile"
        component={Profile}
        key="ManageProfile"
      />
      <Route path="/dashboard/manage/child/edit/:id">
        <AddAndEditChild></AddAndEditChild>
      </Route>
      <Route path="/dashboard/manage/child/add">
        <AddAndEditChild></AddAndEditChild>
      </Route>
      <Route path="/dashboard/manage/child/schedule_permission/:id">
        <SchedulePermission></SchedulePermission>
      </Route>
      <Route
        path="/dashboard/manage/child"
        component={Child}
        key="ManageChild"
      />
      <Route
        path="/dashboard/manage/linked"
        component={LinkedParents}
        key="LinkedParents"
      />
      <Route
        path="/dashboard/manage/credit-card"
        component={ManageCreditCards}
        key="ManageCreditCards"
      />

      <Redirect from="/dashboard/manage" to="/dashboard/manage/profile" />
    </Switch>
  );
});

export default ManageRoute;
